import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import SceneArchive from "./components/SceneArchive";
import Circles from "./components/Circles";
import Rank from "./components/Rank";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <SceneArchive />
      <Circles />
      <Rank />
      <Guide />
      <Faq />
      <About />
      <Footer />
      <BackToTop />
    </main>
  );
}